const images = {
    logo: require('./logo.svg').default,
    logo1: require('./Logo.png'),
    noImage: require('./no-image.png'),
    imageCover: require('./image-cover.jpg'),
    picture1: require('./Picture1.png'),
    picture2: require('./Picture2.png'),
    picture3: require('./Picture3.png'),
    picture4: require('./Picture4.png'),
    picture5: require('./Picture5.png'),
};

export default images;
